import { useEffect } from 'react'

import { withServices } from '@lib/mixins/with-services'
import { withTelemetry } from '@lib/mixins/with-telemetry'

import { type TypePageEntry } from '@contentful-types/page'
import { type TypeSeoMetadataEntry } from '@contentful-types/seo-metadata'
import { type TypeSocialMetadataEntry } from '@contentful-types/social-metadata'

import { IS_BROWSER } from '@constants/globals'

import staticFallbackData from '@components/error-boundary/error-fallback-data.json'
import { CmsPage } from '@components/page-core/page'

const Custom500 = withServices(
  withTelemetry(() => {
    useEffect(() => {
      if (IS_BROWSER) {
        const previousPath = new URLSearchParams(window.location.search).get('previousPath')
        if (previousPath) {
          // Need to use native history API to avoid a rerender, see https://github.com/vercel/next.js/discussions/18072
          setTimeout(() => {
            window.history.replaceState({}, '', previousPath)
          }, 10)
        }
      }
    }, [])

    return (
      <CmsPage
        data={staticFallbackData.data as TypePageEntry}
        metadata={
          staticFallbackData.metadata as {
            social?: TypeSocialMetadataEntry
            seo?: TypeSeoMetadataEntry
          }
        }
        isStaticFallback={true}
      />
    )
  }),
)

export async function getStaticProps() {
  return {
    props: {},
  }
}

export default Custom500
